module.exports = __webpack_public_path__ + "static/media/bfile-vacant-land.c65ce3cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-vacant-land.svg
// module id = 565
// module chunks = 0